/*
  LIORIVE — product page colours as a shade card (2026-10-10, same language as the homepage Nuancier).
  While the pointer rests on a colour band, that colour's own photo (data-lr-preview, from
  snippets/product-variant-options) fades in over the first gallery photo; leaving the bands fades it
  out. Choosing a colour is unchanged (Dawn's variant change). Pointer devices only.
*/
(() => {
  if (!window.matchMedia('(hover: hover)').matches) return;
  let layer = null;
  let current = '';

  // The photo in view: the selected colour's (centred in the strip), else the first (2026-10-28).
  const firstMedia = (fieldset) => {
    const ul = fieldset.closest('product-info, .product')?.querySelector('media-gallery ul.product__media-list');
    const li = ul?.querySelector('li.is-active:not(.lr-strip__clone)') || ul?.querySelector('li:not(.lr-strip__clone)');
    return li?.querySelector('.media, .lr-colour-tile');
  };
  // A colour with no photo of its own previews as a plain field of its colour (data-lr-preview-hex).
  const hexSrc = (hex) =>
    'data:image/svg+xml,' + encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" width="4" height="5"><rect width="4" height="5" fill="' + hex + '"/></svg>');

  const show = (fieldset, src, framed, whole = false) => {
    const media = firstMedia(fieldset);
    if (!media || !src) return;
    if (!layer || !media.contains(layer)) {
      layer = document.createElement('img');
      layer.className = 'lr-preview';
      layer.alt = '';
      layer.setAttribute('aria-hidden', 'true');
      media.appendChild(layer);
    }
    if (current === src) {
      layer.classList.add('is-on');
      return;
    }
    current = src;
    const next = new Image();
    next.src = src;
    next
      .decode()
      .catch(() => {})
      .then(() => {
        if (current !== src || !layer) return;
        layer.src = src;
        layer.classList.toggle('lr-preview--framed', framed);
        layer.classList.toggle('lr-preview--whole', whole);
        layer.classList.add('is-on');
      });
  };

  // The colour name follows the pointer too, then returns to the chosen colour (2026-10-28).
  const nameOf = (el) => el?.closest('variant-selects fieldset, .lr-sib')?.querySelector('[data-selected-value], .lr-opt__value');
  let named = null;
  const setName = (el, text) => {
    const n = nameOf(el);
    if (!n) return;
    if (named !== n) { restoreName(); named = n; n.dataset.lrWas = n.textContent; }
    n.textContent = text;
  };
  const restoreName = () => {
    if (named && named.dataset.lrWas !== undefined) { named.textContent = named.dataset.lrWas; delete named.dataset.lrWas; }
    named = null;
  };

  const hide = () => {
    current = '';
    if (layer) layer.classList.remove('is-on');
    restoreName();
  };

  // Every colour's photo is fetched ahead, once the pointer nears the colours, so the preview is instant.
  let warmed = false;
  const warm = () => {
    if (warmed) return;
    warmed = true;
    document.querySelectorAll('variant-selects [data-lr-preview], .lr-sib__link[data-lr-preview]').forEach((el) => {
      const i = new Image();
      i.src = el.dataset.lrPreview;
    });
  };
  document.addEventListener('pointerover', (e) => {
    if (e.target.closest('.lr-pdp-col--buy, variant-selects, .lr-sib')) warm();
  });

  document.addEventListener('pointerover', (event) => {
    // Pieces sold as one product per colour (snippets/liorive-sibling-colours): each band is a link.
    const sib = event.target.closest('.lr-sib__link');
    if (sib) {
      if (!sib.dataset.lrPreview) return hide();
      setName(sib, (sib.getAttribute('aria-label') || '').replace(/ (épuisé)$/, ''));
      return show(sib.closest('.lr-sib'), sib.dataset.lrPreview, false, sib.dataset.lrPreviewWhole === 'true');
    }
    const label = event.target.closest('variant-selects .swatch-input__label');
    if (!label) return;
    const input = document.getElementById(label.htmlFor);
    if (!input) return;
    if (input.checked) return hide();
    const src = input.dataset.lrPreview || (input.dataset.lrPreviewHex ? hexSrc(input.dataset.lrPreviewHex) : '');
    if (!src) return hide();
    setName(label, input.value);
    show(label.closest('fieldset'), src, input.dataset.lrPreviewFramed === 'true');
  });
  document.addEventListener('pointerout', (event) => {
    const fieldset = event.target.closest('variant-selects fieldset, .lr-sib');
    if (fieldset && !fieldset.contains(event.relatedTarget)) hide();
  });
  // A chosen colour rebuilds the gallery: drop the preview layer.
  document.addEventListener('change', (event) => {
    if (event.target.closest('variant-selects')) {
      hide();
      if (layer) layer.remove();
      layer = null;
    }
  });
})();
